import React, { useEffect } from 'react';
import { Button, Modal } from 'antd';
import { FormLayout } from 'antd/es/form/Form';
import { FormField } from '../../types';
import SubmitButton from './SubmitButton';
import CustomForm from './CustomForm';
import dayjs from 'dayjs';

interface ModalFormProps {
  visible: boolean;
  onClose: () => void;
  formFields: FormField[];
  onFinish: (values: any) => void;
  form: any;
  layout?: FormLayout | undefined;
  data: any;
  setData: (data: any) => void;
  rowCol?: number;
  isLoading?: boolean;
  onValuesChange?: (changedFields: any, allFields: any) => void;
  width?: number;
}

const ModalForm: React.FC<ModalFormProps> = ({
  visible,
  onClose,
  onFinish,
  form,
  data,
  setData,
  formFields,
  layout = 'vertical',
  rowCol,
  isLoading = false,
  onValuesChange,
  width,
}) => {
  const handleFinish = (values: any) => {
    onFinish(values);
    handleFormClose();
  };

  const handleFormClose = () => {
    setData(null);
    onClose();
  };

  useEffect(() => {
    if (data !== null) {
      const defaultValues: any = {};
      formFields.forEach((field) => {
        if (field.type === 'datepicker' && data[field.name]) {
          defaultValues[field.name] = dayjs(data[field.name]);
        } else if (field.type === 'date-range-picker' && data[field.name]) {
          const [startDate, endDate] = data[field.name];
          defaultValues[field.name] = [dayjs(startDate), dayjs(endDate)];
        } else {
          defaultValues[field.name] =
            field.defaultValue !== undefined
              ? field.defaultValue
              : data[field.name];
        }
      });
      form.setFieldsValue(defaultValues);
    }
  }, [data]);
  return (
    <Modal
      width={width}
      title="Modal Form"
      open={visible}
      onCancel={handleFormClose}
      closable={false}
      maskClosable={false}
      footer={[
        <Button key="cancel" onClick={handleFormClose}>
          Cancel
        </Button>,
        <SubmitButton key="submit" form={form}>
          Submit
        </SubmitButton>,
      ]}
    >
      <CustomForm
        data={data}
        form={form}
        onValuesChange={onValuesChange}
        formFields={formFields}
        onFinish={handleFinish}
        layout={layout}
        rowCol={rowCol}
        isLoading={isLoading}
        formName={'form_modal'}
      />
    </Modal>
  );
};

export default ModalForm;
